import gql from 'graphql-tag'

export const ADD_COMPANY = gql`
 mutation insert_company($email: String!,$gstin: String!,$id: uuid!,$mobile: String!,$address: jsonb!,$name: String!,$type: uuid!, $routes: jsonb, $isApproved: Boolean!, $isRejected: Boolean!) {
  insert_company(objects: {email: $email, gstin: $gstin, id: $id, mobile: $mobile, address: $address, name: $name, type: $type, isApproved: $isApproved, isRejected: $isRejected, routes: $routes}) {
    returning {
      id
      name
 }
}
  }
`
export const UPDATE_COMPANY = gql`
 mutation update_company($email: String!,$gstin: String!,$id: uuid!,$mobile: String!,$address: jsonb!,$name: String!,$type: uuid!, $routes: jsonb,  $isApproved: Boolean!, $isRejected: Boolean!) {
  update_company(where: {id: {_eq: $id}}, _set: {email: $email, gstin: $gstin, mobile: $mobile, address: $address, name: $name, type: $type, isApproved: $isApproved, isRejected: $isRejected, routes: $routes}) {
    returning {
      id
 }
}
delete_contacts(where: {clientid: {_eq: $id}}) {
    returning {
      id
     }
    }
delete_CompnayUser(where: {clientid: {_eq: $id}}) {
    returning {
      id
     }
    }
  }
`

export const ADD_COMPANY_TO_ADDRESSBOOK = gql`
 mutation insert_addressbookedcompany($email: String!,$gstin: String!,$id: uuid!,$mobile: String!,$address: jsonb!,$name: String!,$type: uuid!, $parentCompanyId: uuid, $isApproved: Boolean!) {
  insert_addressbookedcompany(objects: {email: $email, gstin: $gstin, id: $id, mobile: $mobile, address: $address, name: $name, type: $type, parentCompanyId: $parentCompanyId, isApproved: $isApproved}) {
    returning {
      id
      name
 }
}
  }
`
export const UPDATE_ADDRESSBOOK_COMPANY = gql`
 mutation update_addressbookedcompany($email: String!,$gstin: String!,$parentCompanyId: uuid!,$mobile: String!,$address: jsonb!,$name: String!,$type: uuid!, $isApproved: Boolean!) {
  update_addressbookedcompany(where: {parentCompanyId: {_eq: $parentCompanyId}}, _set: {email: $email, gstin: $gstin, mobile: $mobile, address: $address, name: $name, type: $type, isApproved: $isApproved}) {
    returning {
      id
 }
}
  }
`

export const DELETE_ADDRESSBOOK_CONTACTS = gql`
 mutation ($clientid: uuid!) {
   delete_addressbookedcontacts(where: {clientid: {_eq: $clientid}}) {
    returning {
      id
     }
    }
  }
`

export const UPDATE_CLIENT = gql`
 mutation update_company($id: uuid!, $object: company_set_input) {
 update_company (
    where: {id: {_eq: $id}}
    _set: $object
  ) {
    returning {
      id
     }
    }
  }
`
export function generate_INSERT_CLIENT_DATA(table) {
  return gql`
 mutation insert_${table}($obj: [${table}_insert_input!]!) {
 insert_${table} (objects: $obj) {
    returning {
      id
     }
    }
  }
`
}

export function generate_DELETE_CLIENT_DATA(table) {
  return gql`
 mutation delete_${table}($id:uuid!) {
 delete_${table} (where:{id:{_eq:$id}}){
    returning {id}
    }
  }
`
}

export const CREATE_UPDATE_ORDER_COMPANY = gql`
mutation saveOrderCompany($orderCompany:[orderCompany_insert_input!]!, $updateColumns: [orderCompany_update_column!]!) {
  insert_orderCompany(objects: $orderCompany, on_conflict: {constraint: orderCompany_orderId_type_key, update_columns: $updateColumns}){
    returning{
      id
    }
  }
}`
